import CustomImageComponent from '@/components/shared/custom/custom-image';
import CustomTeamImageWithDefault from '@/components/shared/custom/CustomTeamImageWithDefault';
import { translate } from '@/data/fixture-transalations';
import { getTimeShortWithYear } from '@/helpers/datetime-helper';
import { getCompetitionImage } from '@/helpers/leagues-helper';
import { Box, Typography } from '@mui/material';

const CalendarioDelJugadorDrawerColumns = () => {
    const columns = [
        {
            id: 'day',
            name: 'Día',
            width: 60,
            center: true,
            cell: (row) => <Typography fontSize={14}>{row.day}</Typography>,
        },
        {
            id: 'partido',
            name: 'Partido',
            center: true,
            cell: (row) => (
                <>
                    {row?.fixture?.homeTeamId ? (
                        <Box display={'flex'} justifyContent={'center'} alignItems={'center'} gap="24px">
                            <Box display={'flex'} gap="4px">
                                <CustomImageComponent
                                    src={getCompetitionImage(row?.fixture?.leagueId, 30)}
                                    alt={'competición'}
                                    width={20}
                                    height={20}
                                />
                                <Typography variant="body2" fontSize={'14px'}>
                                    {translate(row?.fixture?.round, true)}
                                </Typography>
                            </Box>
                            <Box display={'flex'} gap="4px">
                                <CustomTeamImageWithDefault
                                    teamId={row?.fixture?.homeTeamId}
                                    alt={row?.fixture?.homeTeamName}
                                    width={20}
                                    height={20}
                                />
                                <Typography variant="body2" fontSize={'14px'}>
                                    vs
                                </Typography>
                                <CustomTeamImageWithDefault
                                    teamId={row?.fixture?.awayTeamId}
                                    alt={row?.fixture?.awayTeamName}
                                    width={20}
                                    height={20}
                                />
                            </Box>
                        </Box>
                    ) : null}
                </>
            ),
        },
        {
            id: 'fecha',
            name: 'Fecha',
            center: true,
            cell: (row) => <Typography fontSize={12}>{getTimeShortWithYear(row.fixture?.date)}</Typography>,
        },
    ];

    return columns;
};

export default CalendarioDelJugadorDrawerColumns;
